export default __webpack_public_path__ + "static/media/thumb-explore.736c9d2d.png";